import React from 'react';
import ConfirmationPopup from './ConfirmationPopup';
import fileDeleteIcon from '../../../icons/icon-file-delete.png';

const DeleteForeverConfirmation = ({
  onClose,
  onConfirm,
  fileName,
}) => {
  return (
    <ConfirmationPopup
      onClose={onClose}
      onConfirm={onConfirm}
      icon={fileDeleteIcon}
      iconAlt="Delete forever"
      title="Delete forever?"
      description="This action cannot be undone. The item will be permanently deleted."
    />
  );
};

export default DeleteForeverConfirmation;

